const NON_PARTNER_CAPS = [
  { minServices: 4, maxEarnings: 15 },
  { minServices: 2, maxEarnings: 10 },
  { minServices: 0, maxEarnings: 5 },
];

export { NON_PARTNER_CAPS };
